import { Editor } from '@tiptap/core'
import { HeadingTypeEnum } from 'common/enums/HeadingTypeEnum'
import { EditorExtensionEnum } from '../enums/editor-extensions-enum'
import { useToolbarCommands } from './use-toolbar-commands'

export const useGroupedToolbarCommands = (editor: Editor) => {
  const {
    onBold,
    onItalic,
    onUnderline,
    onStrike,
    onSetHeaderOne,
    onSetHeaderTwo,
    onSetHeaderThree,
    onSetHeaderFour,
    onSetHeaderFive,
    onSetHeaderSix,
  } = useToolbarCommands(editor)

  const inlineStylesControls = [
    {
      className: 'fa-solid fa-bold',
      command: onBold,
      type: EditorExtensionEnum.Bold,
    },
    {
      className: 'fa-regular fa-italic',
      command: onItalic,
      type: EditorExtensionEnum.Italic,
    },
    {
      className: 'fa-regular fa-underline',
      command: onUnderline,
      type: EditorExtensionEnum.Underline,
    },
    {
      className: 'fa-regular fa-strikethrough',
      command: onStrike,
      type: EditorExtensionEnum.Strike,
    },
  ]

  const headingControls = [
    {
      className: 'fa-regular fa-h1',
      command: onSetHeaderOne,
      type: HeadingTypeEnum.HeaderOne,
      level: 1,
    },
    {
      className: 'fa-regular fa-h2',
      command: onSetHeaderTwo,
      type: HeadingTypeEnum.HeaderTwo,
      level: 2,
    },
    {
      className: 'fa-regular fa-h3',
      command: onSetHeaderThree,
      type: HeadingTypeEnum.HeaderThree,
      level: 3,
    },
    {
      className: 'fa-regular fa-h4',
      command: onSetHeaderFour,
      type: HeadingTypeEnum.HeaderFour,
      level: 4,
    },
    {
      className: 'fa-regular fa-h5',
      command: onSetHeaderFive,
      type: HeadingTypeEnum.HeaderFive,
      level: 5,
    },
    {
      className: 'fa-regular fa-h6',
      command: onSetHeaderSix,
      type: HeadingTypeEnum.HeaderSix,
      level: 6,
    },
  ]

  return {
    inlineStylesControls,
    headingControls,
  }
}
